<template>
  <div class="not-found-page">
    <div class="not-found-card">
      <p class="not-found-code">404</p>
      <h1 class="not-found-title">URL not found</h1>
      <p class="not-found-message">
        The page you requested does not exist or may have moved.
      </p>
      <p class="not-found-path">Requested URL: {{ route.fullPath }}</p>

      <div class="not-found-actions">
        <router-link to="/" class="not-found-link primary">Go to Home</router-link>
        <router-link to="/sites" class="not-found-link">Go to Sites</router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style scoped>
.not-found-page {
  min-height: 70vh;
  display: grid;
  place-items: center;
  padding: 1.5rem;
}

.not-found-card {
  width: min(42rem, 100%);
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  background: var(--surface-card, #ffffff);
}

.not-found-code {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 700;
}

.not-found-title {
  margin: 0.25rem 0 0.5rem;
  font-size: 1.6rem;
}

.not-found-message {
  margin: 0;
  color: var(--text-color-secondary, #6b7280);
}

.not-found-path {
  margin: 0.85rem 0 0;
  color: var(--text-color-secondary, #6b7280);
  font-size: 0.92rem;
  word-break: break-word;
}

.not-found-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.not-found-link {
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 8px;
  padding: 0.5rem 0.9rem;
  text-decoration: none;
  color: inherit;
}

.not-found-link.primary {
  background: var(--primary-color, #3b82f6);
  color: #fff;
  border-color: var(--primary-color, #3b82f6);
}
</style>
